<template>
    <div>
        <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
            <div>
                <FormInput :front="front" :label="$t('formularios.dni')" name="dni" rules="required" v-model="localBase.dni" />
            </div>

            <div v-if="error" class="alert alert-danger" role="alert">
                {{ error }}
            </div>
            <button type="submit" class="button large-button effect-button"><span>{{ $t('renovar_base.renovar') }}</span></button>
        </ValidationObserver>
    </div>
</template>

<script>
    export default {
        props: ['base', 'error', 'front'],
        data() {
            return {
                localBase: { ...this.base }
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            teatro(){
                return this.$store.getters.getTeatro;
            },
        },
        watch: {
            base: {
                handler(newVal) {
                    this.localBase = { ...newVal };
                },
                deep: true
            }
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.$emit('terminado', this.localBase);
                }
            },
        },
    }
</script>
